/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import {
    faCartPlus, faChevronDown, faChevronUp, faEnvelope
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import Html from 'Component/Html/Html.component';
import Image from 'Component/Image';
import Link from 'Component/Link';
import Loader from 'Component/Loader';
import Popup from 'Component/Popup';
import PRODUCT_TYPE from 'Component/Product/Product.config';
import TextPlaceholder from 'Component/TextPlaceholder';
import YBProductoAsociado from 'Component/YBProductoAsociado';
import YBRecomendadorTalla from 'Component/YBRecomendadorTalla';
import { LIST_LAYOUT } from 'Route/CategoryPage/CategoryPage.config';
import {
    ProductCard as SourceProductCard
} from 'SourceComponent/ProductCard/ProductCard.component';
import { showPopup } from 'Store/Popup/Popup.action';
import { isSignedIn } from 'Util/Auth';
import { scrollToTop } from 'Util/Browser';
import { getTimeInCurrentTimezone } from 'Util/Manipulations/Date';
import { formatPrice, roundDiscount, roundPrice } from 'Util/Price';
import getStore, { getUrlMedia } from 'Util/Store';

import './ProductCard.override.style';

/** @namespace Elganso/Component/ProductCard/Component/showTallasMobile */
export function showTallasMobile(sku) {
    const store = getStore();
    const { dispatch } = store;
    dispatch(showPopup(`popup_tallas_product_card_${sku}`));
}

/** @namespace Elganso/Component/ProductCard/Component */
export class ProductCardComponent extends SourceProductCard {
    handleLinkClick() {
        const { product: { id }, registerSharedElement, isPlp } = this.props;

        if (!isPlp) {
            scrollToTop();
        }

        localStorage.setItem('scrollToProduct', id);
        registerSharedElement(this.imageRef);
    }

    renderAddToCart() {
        const {
            layout,
            showSelectOptionsNotification,
            inStock,
            product,
            handleOutOfStockClick
        } = this.props;

        if (product.type_id === 'configurable') {
            return null;
        }

        if (inStock && this.requiresConfiguration()) {
            return (
                <button
                  block="Button AddToCart"
                  mods={ { layout } }
                  onClick={ showSelectOptionsNotification }
                >
                    { __('Add to cart') }
                </button>
            );
        }

        if (!inStock) {
            return (
                <button
                  block="Button outOfStock"
                  mods={ { layout } }
                  onClick={ handleOutOfStockClick }
                >
                  { __('Agotado') }
                  <FontAwesomeIcon
                    className="faEnvelope"
                    icon={ faEnvelope }
                  />
                </button>
            );
        }

        return this.renderAddToCartButton(layout, true);
    }

    renderPreorder() {
        const { preorder, product } = this.props;
        const finalPreorder = preorder === 0 ? product.preorder : preorder;

        if (finalPreorder) {
            return (
                <div block={ this.className } elem="Preorder">
                    <span className="preorder-title"> (PREORDER)</span>
                </div>
            );
        }
    }

    /**
     * Renders name if { dynamic } is set to true, then will output
     * name to active product AKA configurable products selected variant
     *
     * @param header If header outputs as H1
     * @param dynamic Name type (false - shows parent product only)
     * @returns {JSX.Element}
     */
    renderName(header = true, dynamic = false) {
        const { product: { name }, productName } = this.props;
        const nameToRender = dynamic ? productName : name;

        if (!header) {
            return (
                <p block={ this.className } elem="Name">
                    <TextPlaceholder content={ nameToRender } length="medium" />
                </p>
            );
        }

        return (
            <h1 block={ this.className } elem="Title" itemProp="name">
                <TextPlaceholder content={ nameToRender } length="medium" />
            </h1>
        );
    }
    // #endregion

    renderPrice() {
        const {
            getActiveProduct,
            product,
            product: {
                type_id: baseType
            } = {}
        } = this.props;

        if (product?.configurable_options?.precio_tarjeta_regalo) {
            return null;
        }
        const {
            price_range: priceRange,
            type_id: typeId
        } = getActiveProduct();

        if (!priceRange) {
            return this.renderTextPlaceholder();
        }

        // If product is not a variant.
        const notConfigured = baseType !== PRODUCT_TYPE.configurable || typeId === baseType;

        return super.renderPrice(notConfigured);
    }

    renderCardContent() {
        const {
            product: {
                sku,
                producto_asociado
            }
        } = this.props;

        if (producto_asociado) {
            return (
                <>
                    { this.renderCardLinkContent() }
                    { this.renderPopupOutOfStock() }
                    <YBProductoAsociado
                      sku={ sku }
                      productoAsociado={ producto_asociado }
                    />
                </>
            );
        }

        return (
            <>
                { this.renderCardLinkContent() }
                { this.renderPopupOutOfStock() }
            </>
        );
    }

    renderAgotado() {
        const {
            inStock, handleOutOfStockClick, product, parameters = {}
        } = this.props;

        if (!product || product.type_id !== 'configurable') {
            return null;
        }

        let tieneStock = true;

        if (product.configurable_options.color) {
            tieneStock = false;

            if ('color' in parameters) {
                const product_colors = Object.keys(product.configurable_options.color.attribute_options);

                // COMPROBAR PARAMETRO COLOR CORRESPONDE A UNO DE LOS COLORES DEL PRODUCTO
                if (product_colors.find((e) => e === parameters.color)) {
                    tieneStock = product.variants.some((childProduct) => {
                        if (childProduct.attributes.color.attribute_value === parameters.color && childProduct.stock_status === 'IN_STOCK') {
                            return true;
                        }
                    });
                } else {
                    tieneStock = product.variants.some((childProduct) => {
                        if (childProduct.attributes.color.attribute_value === product_colors[0] && childProduct.stock_status === 'IN_STOCK') {
                            return true;
                        }
                    });
                }
            } else {
                tieneStock = product.variants.some((childProduct) => {
                    if (childProduct.stock_status === 'IN_STOCK') {
                        return true;
                    }
                });
            }
        } else {
            tieneStock = false;
            tieneStock = product.variants.some((childProduct) => {
                if (childProduct.stock_status === 'IN_STOCK') {
                    return true;
                }
            });
        }

        if (!inStock || !tieneStock) {
            return (
                <div
                  block="productoagotado"
                  onClick={ () => handleOutOfStockClick(parameters) }
                  onKeyUp={ () => {} }
                >
                  { __('Agotado') }
                  <FontAwesomeIcon
                    className="faEnvelope"
                    icon={ faEnvelope }
                  />
                </div>
            );
        }

        return null;
    }

    renderProductCardWishlistButton() {
        const { hideWishlistButton, isWishlistEnabled } = this.props;

        if (hideWishlistButton || !isWishlistEnabled) {
            return null;
        }

        return this.renderWishlistButton();
    }

    renderTag() {
        const {
            product: {
                attributes: {
                    product_tag,
                    news_from_date,
                    news_to_date
                } = ''
            },
            currentDate
        } = this.props;

        if (news_to_date?.attribute_value && product_tag?.attribute_value) {
            const productTagFrom = new Date(news_from_date?.attribute_value);
            const productTagTo = new Date(news_to_date?.attribute_value);
            if (productTagFrom < currentDate && productTagTo > currentDate) {
                const srcImage = `${getUrlMedia()}option_image/${product_tag?.attribute_value}.png`;
                return (
                    <div block="ProductCard" elem="ProductTag">
                        <img src={ srcImage } alt="Product tag" />
                    </div>
                );
            }
        }

        return null;
    }

    renderYBRecomendadorTallas() {
        const { product, showRecomendador, showGuiaDeTallas } = this.props;

        if (product.type_id !== PRODUCT_TYPE.bundle) {
            return (
                <div className="RecomendadorContainer">
                    <button
                      onClick={ showGuiaDeTallas }
                      rel="noopener noreferrer"
                      target="_blank"
                      className="show-guia-tallas"
                    >
                        { __('Size Guide') }
                        <FontAwesomeIcon icon={ showRecomendador ? faChevronUp : faChevronDown } />
                    </button>
                    { showRecomendador ? (
                        <YBRecomendadorTalla
                          key={ product.sku }
                          product={ product }
                          isShowPopup={ false }
                        />
                    ) : null }
                </div>
            );
        }

        return null;
    }

    renderCardLinkContent() {
        const {
            device,
            inStock,
            layout,
            renderContent,
            product: {
                type_id,
                attributes: {
                    producto_wp,
                    short_description
                } = '',
                sku = null
            },
            product
        } = this.props;

        if (renderContent) {
            return renderContent(this.contentObject);
        }

        if (producto_wp?.attribute_value === '1') {
            if (short_description !== undefined && short_description.attribute_value !== null && short_description.attribute_value !== '') {
                const imagenCreatividad = short_description.attribute_value;

                if (imagenCreatividad.includes('<p>')) {
                    return (
                        <div block="ProductCard" elem="ImageCreatividad">
                            <Html content={ imagenCreatividad } />
                        </div>
                    );
                }

                return (
                    <div block="ProductCard" elem="ImageCreatividad">
                        <p>
                            <Html content={ imagenCreatividad } />
                        </p>
                    </div>
                );
            }

            return (
                <div block="ProductCard" elem="LinkInnerWrapper">
                    { this.renderCardLinkWrapper((
                    <div block="ProductCard" elem="FigureReview">
                        <figure block="ProductCard" elem="Figure">
                            <Html content={ short_description.attribute_value } />
                        </figure>
                    </div>
                    )) }
                </div>
            );
        }

        let classContentBlock = '';

        if (type_id !== 'configurable' || !product?.configurable_options?.color) {
            classContentBlock += 'not-configurable';
        }

        if (device.isMobile) {
            return (
                <div block="ProductCard" elem="LinkInnerWrapper">
                    { this.renderCardLinkWrapper((
                    <div block="ProductCard" elem="FigureReview">
                        <figure block="ProductCard" elem="Figure">
                            { this.renderPicture() }
                        </figure>
                        <div block="ProductCard" elem="ProductActions">
                            { sku !== null ? this.renderProductCardWishlistButton() : null }
                        </div>
                        { this.renderTag() }
                    </div>
                    )) }
                    <div block="ProductCard" elem="Content" className={ classContentBlock }>
                        <div block="ProductCard" elem="MobilePopup">
                            { product?.configurable_options?.precio_tarjeta_regalo
                                ? null
                                : (
                                    <>
                                        { // eslint-disable-next-line no-nested-ternary
                                            type_id === 'configurable'
                                                ? (
                                                    <button
                                                      block="Button AddToCart"
                                                      mods={ { layout } }
                                                      onClick={ () => showTallasMobile(sku) }
                                                    >
                                                        <FontAwesomeIcon icon={ faCartPlus } />
                                                    </button>
                                                )
                                                // eslint-disable-next-line react/jsx-curly-newline
                                                : sku !== null && inStock && type_id !== 'bundle' ? this.renderAddToCart() : null }
                                        <Popup
                                          id={ `popup_tallas_product_card_${sku}` }
                                          clickOutside
                                          mix={ { block: 'ConfigurableOptionsMobile' } }
                                        >
                                            <div className="Popup-SizesContent">
                                                <div mix={ { block: 'TitleAddSize' } }>
                                                    { __('Elige tu talla') }
                                                </div>
                                                { this.renderConfigurableOptions() }
                                                { this.renderYBRecomendadorTallas() }
                                            </div>
                                        </Popup>
                                    </>
                                ) }
                        </div>
                        { this.renderCardLinkWrapper((
                            this.renderBrand(),
                            this.renderName(false)
                        )) }
                        { product?.configurable_options?.color ? this.renderConfigurableOptions() : null }
                        <div block="ProductCard" elem="Footer">
                            <div block="ProductCard" elem="FooterBlock">
                                { this.renderCardLinkWrapper((
                                    this.renderPrice()
                                )) }
                                { this.renderAgotado() }
                                { this.renderPreorder() }
                                { type_id === 'simple' && !inStock ? this.renderAddToCart() : null }
                            </div>
                            { this.renderPromoCarrito() }
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div block="ProductCard" elem="LinkInnerWrapper">
                { this.renderCardLinkWrapper((
                <div block="ProductCard" elem="FigureReview">
                    <figure block="ProductCard" elem="Figure">
                        { this.renderPicture() }
                    </figure>
                    <div block="ProductCard" elem="ProductActions">
                        { sku !== null ? this.renderProductCardWishlistButton() : null }
                    </div>
                    { this.renderTag() }
                </div>
                )) }
                <div block="ProductCard" elem="Content" className={ classContentBlock }>
                    { sku !== null && inStock && type_id !== 'bundle' ? this.renderAddToCart() : null }
                    { this.renderCardLinkWrapper((
                        this.renderBrand(),
                        this.renderName(false)
                    )) }
                    { this.renderConfigurableOptions() }
                    <div block="ProductCard" elem="Footer">
                        <div block="ProductCard" elem="FooterBlock">
                            { this.renderCardLinkWrapper((
                                this.renderPrice()
                            )) }
                            { this.renderAgotado() }
                            { this.renderPreorder() }
                            { sku !== null && (type_id === 'simple' && !inStock) ? this.renderAddToCart() : null }
                        </div>
                        { this.renderPromoCarrito() }
                    </div>
                </div>
            </div>
        );
    }

    renderPromoCarrito() {
        const {
            ConfigReducer: {
                currencyData: {
                    current_currency_code
                },
                carritoPromocionesData
            }
        } = getStore().getState();
        const {
            product: {
                yeboyebo_carrito_promociones_precio,
                price_range
            }
        } = this.props;

        if (!carritoPromocionesData) {
            return null;
        }

        if (this.mostrarPromocion(carritoPromocionesData)) {
            const {
                texto_promo_item
            } = carritoPromocionesData;
            const precioFormat = formatPrice(roundPrice(yeboyebo_carrito_promociones_precio), current_currency_code);
            const finalPriceValue = price_range?.maximum_price?.final_price?.value;
            // const porcentaje = Math.round(100 - ((Math.round((yeboyebo_carrito_promociones_precio / finalPriceValue) * 20, 0) / 20) * 100));
            const discount = 100 - ((yeboyebo_carrito_promociones_precio * 100) / finalPriceValue);
            const porcentaje = roundDiscount(discount);

            return (
                (porcentaje) ? (
                    <div
                      block="ProductCard"
                      elem="promo"
                    >
                    { texto_promo_item } <span className="priceProductCard">{ precioFormat }</span> <span className="porcentajeProductCard">-{ porcentaje }% </span>
                    </div>
                ) : (

                    <div
                      block="ProductCard"
                      elem="promo"
                    >
                    { texto_promo_item } <span className="priceProductCard">{ precioFormat }</span>
                    </div>
                )
            );
        }

        return '';
    }

    mostrarPromocion(carritoPromocionesData) {
        const {
            product: {
                yeboyebo_carrito_promociones_fecha_hasta,
                price_range,
                yeboyebo_carrito_promociones_precio
            }
        } = this.props;

        let tienePrecioPromo = false;
        if (price_range?.maximum_price?.final_price?.value && yeboyebo_carrito_promociones_precio) {
            if (price_range.maximum_price.final_price.value > yeboyebo_carrito_promociones_precio) {
                tienePrecioPromo = true;
            }
        }

        const {
            enabled,
            promo_registrados
        } = carritoPromocionesData;

        if (enabled) {
            if ((promo_registrados && isSignedIn()) || !promo_registrados) {
                if (yeboyebo_carrito_promociones_fecha_hasta) {
                    const ahora = Date.now();
                    const fechaPromo = Date.parse(getTimeInCurrentTimezone(yeboyebo_carrito_promociones_fecha_hasta));
                    if (ahora < fechaPromo && tienePrecioPromo) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    renderCardLinkWrapper(children, mix = {}) {
        const {
            linkTo,
            product: {
                url,
                url_rewrites,
                attributes: {
                    producto_wp
                } = ''
            }
        } = this.props;
        const final_url = linkTo;

        if (linkTo.pathname !== undefined && linkTo.pathname.includes('catalog') && url_rewrites.length > 0 && url_rewrites[0] !== undefined) {
            final_url.pathname = url_rewrites[0].url;
        }

        if (!url || producto_wp.attribute_value === '1') {
            return (
                <div
                  block="ProductCard"
                  elem="Link"
                >
                    { children }
                </div>
            );
        }

        return (
            <Link
              block="ProductCard"
              elem="Link"
              to={ final_url }
              onClick={ this.handleLinkClick }
              mix={ mix }
            >
                { children }
            </Link>
        );
    }

    renderPicture(mix = {}) {
        const { product: { id, name, image }, thumbnail, isAddingToCart } = this.props;

        let imagenPoner = thumbnail;

        if (thumbnail.includes('placeholder')) {
            imagenPoner = image.url;
        }

        return (
            <>
                <Image
                  imageRef={ this.imageRef }
                  src={ imagenPoner }
                  alt={ name }
                  ratio="custom"
                  mix={ { block: 'ProductCard', elem: 'Picture', mix } }
                  isPlaceholder={ !id }
                />
                <Loader key={ id } isLoading={ isAddingToCart } />
            </>
        );
    }

    render() {
        const {
            children,
            mix,
            isLoading,
            layout,
            product: {
                id,
                sku,
                attributes: {
                    producto_wp
                } = ''
            },
            hoverProductCard,
            actualHoverProductCard,
            leavehoverProductCard
        } = this.props;

        let clases = id;

        if (producto_wp?.attribute_value === '1') {
            clases += ' creatividad';
        }

        if (actualHoverProductCard) {
            clases += ' product-hovered';
        }

        if (layout === LIST_LAYOUT) {
            return (
                <li
                  block="ProductCard"
                  mods={ { layout } }
                  mix={ mix }
                  key={ sku }
                  className={ clases || '' }
                >
                    <Loader key={ sku } isLoading={ isLoading } />
                    { this.renderCardListContent() }
                </li>
            );
        }

        return (
            <li
              block="ProductCard"
              mods={ { layout } }
              mix={ mix }
              key={ sku }
              className={ clases || '' }
              onMouseEnter={ hoverProductCard }
              onMouseLeave={ leavehoverProductCard }
            >
                <Loader key={ sku } isLoading={ isLoading } />
                { this.renderCardContent() }
                { children !== null
                    ? (
                        <div block="ProductCard" elem="AdditionalContent">
                            { children }
                        </div>
                    )
                    : '' }
            </li>
        );
    }
}

// eslint-disable-next-line @scandipwa/scandipwa-guidelines/export-level-one
function areEqual(prevProps, nextProps) {
    return (
        prevProps.parameters === nextProps.parameters
        && prevProps.isAddingToCart === nextProps.isAddingToCart
        && prevProps.actualHoverProductCard === nextProps.actualHoverProductCard
        && prevProps.showRecomendador === nextProps.showRecomendador
    );
}

export default memo(ProductCardComponent, areEqual);
